import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function ContentList3({ data }) {
    const { contentList3ButtonEmailLink, contentList3ButtonText, contentList3Title, contentList3ButtonType, contentList3ButtonPageLink, contentList3Block, contentList3ButtonExternalLink } = data
    return (
        <div className='global-image-content-wrap changemarker-image-c-wrp'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-2 blue-color'>
                            {contentList3Title && parser(contentList3Title)}
                        </h2>
                    </div>
                </div>
                {contentList3Block.map((item, index) => (
                    <div className='row' key={index}>
                        <div className='col-md-6 gc-img-col'>
                            <GatsbyImage
                                image={getImage(item.contentList3BlockImage?.localFile)}
                                alt='image'
                            />
                        </div>
                        <div className='col-md-6 gc-c-col'>
                            <div className='global-img-content-rt-sec'>
                                <h3 className='heading-level-3 blue-color'>
                                    {item.contentList3BlockTitle && parser(item.contentList3BlockTitle)}
                                </h3>
                                <p>
                                    <strong>{item.contentList3BlockSubtitle && parser(item.contentList3BlockSubtitle)}</strong>
                                </p>
                                {item.contentList3BlockText && parser(item.contentList3BlockText)}
                            </div>
                        </div>
                    </div>
                ))}

                <div className='row text-center mt-4 sm-full-btn'>
                    <div className='col-md-12'>
                        {contentList3ButtonType == 'email' && (
                            contentList3ButtonEmailLink && (
                                <a
                                    href={`mailto:${contentList3ButtonEmailLink}`}
                                    className='btn blue-btn'
                                >
                                    {contentList3ButtonText}
                                </a>
                            )
                        ) || contentList3ButtonType == 'internal' && (
                            contentList3ButtonPageLink && (
                                <Link
                                    to={contentList3ButtonPageLink.uri}
                                    className='btn blue-btn'
                                >
                                    {contentList3ButtonText}
                                </Link>
                            )
                        ) || contentList3ButtonType == 'external' && (
                            contentList3ButtonExternalLink && (
                                <a href={contentList3ButtonExternalLink} className="btn blue-btn">
                                    {contentList3ButtonText}
                                </a>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
